import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Checkbox,
  Typography,
  Popconfirm,
  Badge
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import { FileTwoTone } from "@ant-design/icons";
import { trainingAPI } from "../../api/TrainingAPI.js";
import { useSelector } from "react-redux";
import { useDataAccess, PermissionedButton } from "@components/PermissionedComponents";

const { Text } = Typography;

export function GetWellnessReportButton(props) {
  const {
    info: {
      coach_list,
    },
    filter: {
      endDate,

    },
  } = useSelector(({ team }) => team);

  const {
    currentUser: { email: currentUserEmail },
  } = useSelector(({ auth }) => auth);

  const [selectedEmails, setSelectedEmails] = useState({});
  const [surveyResponseCount, setSurveyResponseCount] = useState(undefined);

  const { canAccess, ready: permissionsReady } = useDataAccess();

  useEffect(() => {
    if (!endDate) {
      message.error("Please select valid date to generate the report");
      return;
    }

    // Survey response counts are wellness data and 403 without access.
    if (!permissionsReady || !canAccess("wellness")) return;

    trainingAPI
    .surveyreponsecount(endDate)
    .then((data) => setSurveyResponseCount(data))
    .catch((err) => {
      console.log(err);
      setSurveyResponseCount(undefined);
    });
  }, [endDate, permissionsReady]);


  const onChangeEmailSelection = (option) => {
    setSelectedEmails({ ...selectedEmails, [option]: !selectedEmails[option] });
  };

  const sendWellnessEmail = () => {
    if (!endDate) {
      message.error("Please select valid date to generate the report");
      return;
    }

    let emails = Object.keys(selectedEmails).filter(
      (key) => selectedEmails[key] === true
    );
    if (emails.length == 0) {
      message.info("Please select at least one email recipient for the report");
      return;
    }


    trainingAPI
      .wellnessEmail(endDate, emails)
      .then((data) => {
        message.success("Email Sent!");
      })
      .catch((data) => {
        message.error("Error sending email.");
      });
  };

  const handleWellnessNotification = () => {
    trainingAPI
      .sendWellnessNotification(endDate)
      .then((data) => {
        message.success(data);
      })
      .catch((data) => {
        message.error(data);
      });
  };

  const handleRPENotification = () => {
    trainingAPI
      .sendRPENotification(endDate)
      .then((data) => {
        message.success(data);
      })
      .catch((data) => {
        message.error(data);
      });
  };

  const sendNotificationButtons = (
    <>
      <hr />
      <Row gutter={[0, 8]} align="middle">
        <Col span={12}>
          <Button
            className="survey-count-button"
            type="primary"
            onClick={handleWellnessNotification}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span>Send</span>
              <b>Wellness survey</b>
              <span>notification</span>
              <Badge
                color="geekblue"
                count={`${
                  (
                    surveyResponseCount?.wellness?.filter(
                      (x) => x.submitted === true
                    ) || []
                  ).length
                } / ${surveyResponseCount?.wellness?.length || 0}`}
              />
            </div>
          </Button>
        </Col>

        <Col span={12}>
          <Button
            className="survey-count-button"
            type="primary"
            onClick={handleRPENotification}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span>Send</span>
              <b>RPE survey</b>
              <span>notification</span>
              <Badge
                color="geekblue"
                count={`${
                  (
                    surveyResponseCount?.rpe?.filter(
                      (x) => x.submitted === true
                    ) || []
                  ).length
                } / ${surveyResponseCount?.rpe?.length || 0}`}
              />
            </div>
          </Button>
        </Col>
      </Row>
      <hr />
    </>
  );

  const popConfirmText = (
    <>
      <Text>
        Would you like to generate a detailed report?
        <br />
      </Text>
      <div style={{ marginTop: "0.5em" }}>
        Please select the emails that should receive the report:
      </div>

      <Col style={{ marginTop: "0.5em" }}>
        {coach_list
          .filter((x) => x.email == currentUserEmail)
          .map((item) => (
            <Row key={item.email}>
              <Checkbox
                checked={selectedEmails[item.email] || false}
                onChange={() => onChangeEmailSelection(item.email)}
              >
                {item.first_name} {item.last_name}{" "}
                <span style={{ fontSize: 13 }}>({item.email})</span>
              </Checkbox>
            </Row>
          ))}
        {coach_list
          .filter((x) => x.email != currentUserEmail)
          .map((item, index) => (
            <Row key={index}>
              <Checkbox
                checked={selectedEmails[item.email] || false}
                onChange={() => onChangeEmailSelection(item.email)}
              >
                {item.first_name} {item.last_name}{" "}
                <span style={{ fontSize: 13 }}>({item.email})</span>
              </Checkbox>
            </Row>
          ))}
      </Col>

      {sendNotificationButtons}
    </>
  );

  return (
    <Popconfirm
      placement="bottom"
      onConfirm={sendWellnessEmail}
      icon={<FileTwoTone />}
      okText="Yes"
      cancelText="No"
      title={popConfirmText}
    >
      <PermissionedButton permissionCheck="AccessWellnessData">
        Get Report
      </PermissionedButton>
    </Popconfirm>
  );

};
